import { Paper, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import { useT } from "../../i18n";
import AbladestellenDatatable from "../../components/abladestellen/AbladestellenDatatable";
import React from "react";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import Guard from "../../components/Guard";

export default function AbladestellenListe() {
  const { t } = useT("abladestelle");
  const limit = parseInt(
    localStorage.getItem("abladestellenLimit") ?? "25",
    10
  );
  return (
    <Layout title={t("landfill-and-unloading-point")} showTitleInNav={false}>
      <Guard
        permission={"abladestelle:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">
            {t("landfill-and-unloading-point")}
          </Typography>
          <AbladestellenDatatable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
